// extracted by mini-css-extract-plugin
export default {"required":"style_required__ugbad"};